import type { AssetId, Scenario } from './types';

export type Contribution = { shockId:string; label:{zh:string;en:string}; channel:{zh:string;en:string}; value:number; sensitivity:number; conditions:{zh:string;en:string} };
export type BalanceResult = { asset:AssetId; contributions:Contribution[]; up:number; down:number; net:number; gross:number; reading:'strong-offset'|'both-small'|'mixed'|'one-sided' };

const MIN_OPPOSING_SHARE = 0.1;
const STRONG_OFFSET_SHARE = 0.4;

export function calculateBalances(scenario:Scenario, surpriseScale=1): BalanceResult[] {
  const assets:AssetId[]=['gold','oil','tech','bonds','usd'];
  return assets.map(asset=>{
    const contributions=scenario.shocks.map(shock=>{
      const sensitivity=shock.assetSensitivity[asset] ?? 0;
      return {shockId:shock.id,label:shock.label,channel:shock.channel,value:Math.round(shock.surprise*surpriseScale*sensitivity*100)/100,sensitivity,conditions:shock.conditions};
    }).filter(item=>item.sensitivity!==0);
    const up=contributions.reduce((sum,c)=>sum+Math.max(0,c.value),0);
    const down=contributions.reduce((sum,c)=>sum+Math.max(0,-c.value),0);
    const net=Math.round((up-down)*100)/100;
    const gross=Math.round((up+down)*100)/100;
    const opposingShare=gross===0?0:Math.min(up,down)/gross;
    const reading = gross < 1
      ? (gross === 0 || (up > 0 && down > 0) ? 'both-small' : 'one-sided')
      : opposingShare < MIN_OPPOSING_SHARE
        ? 'one-sided'
        : opposingShare < STRONG_OFFSET_SHARE
          ? 'mixed'
          : 'strong-offset';
    return {asset,contributions,up,down,net,gross,reading};
  });
}

export function makeLayerGraph(scenario:Scenario) {
  return scenario.shocks.map(shock=>({
    id:shock.id,label:shock.label,channel:shock.channel,conditions:shock.conditions,
    affected:(Object.entries(shock.assetSensitivity) as [AssetId,number][]).map(([asset,sensitivity])=>({asset,sensitivity,value:Math.round(shock.surprise*sensitivity*100)/100})),
  }));
}
